import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/destination.css';

export default class Rameshwaram extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'overview'
    };
  }

  render() {
    const attractions = [
      {
        name: "Ramanathaswamy Temple",
        image: "/assets/img/rameshwaram-temple-inside.jpg",
        description: "One of the 12 Jyotirlinga temples dedicated to Lord Shiva. Famous for its longest corridor among all Hindu temples in India with 1,212 pillars.",
        highlight: "Jyotirlinga Temple",
        bestTime: "Morning/Evening",
        duration: "2-3 Hours",
        tip: "Visit during evening aarti for spiritual experience"
      },
      {
        name: "Agni Theertham",
        image: "/assets/img/agni-theertham.jpg",
        description: "A sacred beach where Lord Rama is believed to have worshipped Lord Shiva. Pilgrims take a holy dip before visiting the temple.",
        highlight: "Sacred Beach",
        bestTime: "Sunrise",
        duration: "1 Hour",
        tip: "Best for sunrise prayers"
      },
      {
        name: "Dhanushkodi",
        image: "/assets/img/dhanushkodi-bg.jpg",
        description: "A ghost town at the southern tip of Rameswaram, destroyed by a cyclone in 1964. Offers stunning views of the Bay of Bengal and Indian Ocean.",
        highlight: "Ghost Town",
        bestTime: "Morning",
        duration: "2-3 Hours",
        tip: "Take a jeep safari for the full experience"
      },
      {
        name: "Adam's Bridge (Rama Setu)",
        image: "/assets/img/adams-bridge.jpg",
        description: "A chain of limestone shoals connecting India and Sri Lanka, believed to be the bridge built by Lord Rama's army.",
        highlight: "Mythological Bridge",
        bestTime: "Morning",
        duration: "1-2 Hours",
        tip: "Best viewed from Dhanushkodi"
      },
      {
        name: "Pamban Bridge",
        image: "/assets/img/pamban-bridge-view.jpg",
        description: "India's first sea bridge connecting Rameswaram to mainland. A marvel of engineering with a double-leaf bascule section.",
        highlight: "Engineering Marvel",
        bestTime: "All Day",
        duration: "30 mins",
        tip: "Watch the bridge open for ships"
      },
    //   {
    //     name: "Gandhi Mandapam",
    //     image: "/assets/img/gandhi-mandapam.jpg",
    //     description: "A memorial dedicated to Mahatma Gandhi, located at the spot where his ashes were kept before immersion.",
    //     highlight: "Historic Memorial",
    //     bestTime: "Morning",
    //     duration: "30 mins",
    //     tip: "Beautiful architecture and views"
    //   },
      {
        name: "Kothandaramaswamy Temple",
        image: "/assets/img/kothandaramaswamy.jpg",
        description: "An ancient temple in Dhanushkodi where Vibhishana surrendered to Lord Rama. One of the few structures surviving the 1964 cyclone.",
        highlight: "Ancient Temple",
        bestTime: "Morning",
        duration: "1 Hour",
        tip: "Part of Dhanushkodi tour"
      },
      {
        name: "Five-faced Hanuman Temple",
        image: "/assets/img/hanuman-temple.jpeg",
        description: "Temple housing a floating stone believed to have been used to build Rama Setu. Features a five-faced idol of Hanuman.",
        highlight: "Floating Stones",
        bestTime: "Morning/Evening",
        duration: "45 mins",
        tip: "See the floating stone exhibit"
      }
    ];

    const experiences = [
      {
        title: "Temple Pilgrimage",
        description: "Visit the sacred Ramanathaswamy Temple and 22 theerthams",
        icon: "fas fa-pray"
      },
      {
        title: "Beach Exploration",
        description: "Explore pristine beaches at Agni Theertham and Dhanushkodi",
        icon: "fas fa-umbrella-beach"
      },
      {
        title: "Historical Tour",
        description: "Discover the ghost town of Dhanushkodi and its history",
        icon: "fas fa-landmark"
      },
      {
        title: "Photography",
        description: "Capture stunning sunrise, sunset, and architectural marvels",
        icon: "fas fa-camera"
      }
    ];

    const quickInfo = [
      { label: "Location", value: "Ramanathapuram District, Tamil Nadu", icon: "fas fa-map-marker-alt" },
      { label: "Best Time to Visit", value: "October to April", icon: "fas fa-calendar-alt" },
      { label: "Nearest Airport", value: "Madurai Airport (163 km)", icon: "fas fa-plane" },
      { label: "Nearest Railway", value: "Rameswaram Railway Station (1 km)", icon: "fas fa-train" },
      { label: "Famous For", value: "Jyotirlinga Temple, Pamban Bridge", icon: "fas fa-hands-praying" },
      { label: "Language", value: "Tamil, English, Hindi", icon: "fas fa-language" }
    ];

    const theerthams = [
      { name: "Agni Theertham", significance: "Lord Rama worshipped Lord Shiva here" },
      { name: "Kavatcha Theertham", significance: "Holy dip here cleanses sins" },
      { name: "Brahma Theertham", significance: "Believed to be created by Lord Brahma" },
      { name: "Surya Theertham", significance: "Dedicated to Sun God" }
    ];

    const templeFacts = [
      { label: "Longest Corridor", value: "1,212 pillars, 197 meters" },
      { label: "Jyotirlinga", value: "One of 12 sacred Jyotirlingas" },
      { label: "Temple Area", value: "15 acres" },
      { label: "Towers (Gopurams)", value: "3 majestic towers" }
    ];

    return (
      <div className="dest-destination-page">
        {/* Hero Section */}
        <div className="destination-hero">
          <div className="dest-hero-overlay"></div>
          <div className="dest-hero-background">
            <img src="/assets/img/rameshwaram-hero.png" alt="Rameswaram Temple" />
          </div>
          <div className="dest-hero-content">
            <div className="dest-hero-badge">
              <span>Island of Divine Grace</span>
            </div>
            <h1 className="dest-hero-title">Rameswaram</h1>
            <p className="dest-hero-subtitle">
              Where spirituality meets the sea, and mythology comes alive
            </p>
            <div className="dest-hero-location">
              <i className="fas fa-map-marker-alt"></i>
              <span>Ramanathapuram District, Tamil Nadu, India</span>
            </div>
          </div>
          <div className="dest-hero-scroll">
            <span>Scroll to explore</span>
            <i className="fas fa-chevron-down"></i>
          </div>
        </div>

        {/* Introduction Section */}
        <div className="dest-intro-section">
          <Grid>
            <Row>
              <Col xs={12} md={7} className="dest-intro-text">
                <h2 className="dest-section-title">Welcome to Rameswaram</h2>
                <p className="dest-intro-description">
                  Rameswaram, a sacred island town in Tamil Nadu, is one of the holiest pilgrimage 
                  sites for Hindus. It is part of the Char Dham pilgrimage and home to the 
                  Ramanathaswamy Temple, famous for its longest corridor among all Hindu temples in India.
                </p>
                <p className="dest-intro-description">
                  According to Hindu mythology, Lord Rama built a bridge (Rama Setu) from here to 
                  Lanka to rescue his wife Sita. The town is also known for its pristine beaches, 
                  the ghost town of Dhanushkodi, and the engineering marvel of Pamban Bridge.
                </p>
                <div className="dest-highlight-box">
                  <i className="fas fa-star"></i>
                  <span>Did You Know? The Ramanathaswamy Temple has the longest corridor among all Hindu temples in India, with 1,212 pillars spanning 197 meters.</span>
                </div>
              </Col>
              <Col xs={12} md={5} className="dest-quick-info">
                <h3>Quick Facts</h3>
                <div className="dest-info-grid">
                  {quickInfo.map((info, index) => (
                    <div key={index} className="dest-info-card">
                      <div className="dest-info-icon">
                        <i className={info.icon}></i>
                      </div>
                      <div className="dest-info-content">
                        <span className="dest-info-label">{info.label}</span>
                        <span className="dest-info-value">{info.value}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Experiences Section */}
        <div className="dest-experiences-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title-centered">Experiences in Rameswaram</h2>
            <p className="dest-section-subtitle">
              Spiritual and scenic experiences on the island
            </p>
          </div>
          <Grid>
            <Row className="experiences-grid">
              {experiences.map((exp, index) => (
                <Col xs={12} sm={6} md={3} key={index} className="experience-col">
                  <div className="experience-card">
                    <div className="exp-icon">
                      <i className={exp.icon}></i>
                    </div>
                    <h4 className="exp-title">{exp.title}</h4>
                    <p className="description">{exp.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Temple Section */}
        <div className="temple-section-rameshwaram">
          <div className="temple-overlay"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="temple-content-rameshwaram">
                <div className="temple-badge-rameshwaram">Sacred Jyotirlinga</div>
                <h2 className="temple-title-rameshwaram">Sri Ramanathaswamy Temple</h2>
                <p className="temple-description-rameshwaram">
                  The Ramanathaswamy Temple is dedicated to Lord Shiva and is one of the 12 
                  Jyotirlinga temples in India. The temple's architecture is a masterpiece of 
                  Dravidian style, featuring towering gopurams and the longest corridor of any 
                  Hindu temple in the world.
                </p>
                <p className="temple-description-rameshwaram">
                  The temple has 22 sacred theerthams (holy water bodies) within its premises, 
                  where pilgrims take a holy dip before worship. The main deity, Ramanathaswamy 
                  (Lord Shiva), was worshipped by Lord Rama to absolve his sins before his battle 
                  with Ravana.
                </p>
                <div className="temple-facts-grid">
                  {templeFacts.map((fact, index) => (
                    <div key={index} className="temple-fact">
                      <span className="fact-label">{fact.label}</span>
                      <span className="fact-value">{fact.value}</span>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Theerthams Section */}
        <div className="theerthams-section">
          <Grid>
            <div className="section-header">
              <h2 className="section-title-centered">Sacred Theerthams</h2>
              <p className="section-subtitle">
                The 22 holy water bodies within the temple premises
              </p>
            </div>
            <Row className="theerthams-grid">
              {theerthams.map((theertham, index) => (
                <Col xs={12} sm={6} md={3} key={index} className="theertham-col">
                  <div className="theertham-card">
                    <div className="theertham-icon">
                      <i className="fas fa-water"></i>
                    </div>
                    <h4 className="theertham-name">{theertham.name}</h4>
                    <p className="theertham-significance">{theertham.significance}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Attractions Section */}
        <div className="attractions-section">
          <div className="section-header">
            <h2 className="section-title-centered">Top Attractions in Rameswaram</h2>
            <p className="section-subtitle">
              Discover the spiritual and scenic wonders
            </p>
          </div>

          <Grid>
            <Row className="dest-attractions-grid">
              {attractions.map((attraction, index) => (
                <Col xs={12} sm={6} md={4} lg={3} key={index} className="dest-attraction-col">
                  <div className="dest-attraction-card">
                    <div className="dest-card-image">
                      <img src={attraction.image} alt={attraction.name} />
                      <div className="dest-card-overlay">
                        <span className="dest-highlight-tag">{attraction.highlight}</span>
                      </div>
                    </div>
                    <div className="dest-card-content">
                      <h3 className="dest-attraction-name">{attraction.name}</h3>
                      <p className="dest-attraction-description">{attraction.description}</p>
                      <div className="dest-card-footer">
                        <div className="time-info">
                          <span className="dest-best-time">
                            <i className="far fa-calendar"></i>
                            {attraction.bestTime}
                          </span>
                          <span className="dest-duration">
                            <i className="far fa-clock"></i>
                            {attraction.duration}
                          </span>
                        </div>
                        <div className="dest-travel-tip">
                          <i className="fas fa-lightbulb"></i>
                          <span>{attraction.tip}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Dhanushkodi Section */}
        <div className="dhanushkodi-section">
          <div className="dhanushkodi-overlay"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="dhanushkodi-content">
                <div className="dhanushkodi-badge">Ghost Town</div>
                <h2 className="dhanushkodi-title">Dhanushkodi - The Ghost Town</h2>
                <p className="dhanushkodi-description">
                  Dhanushkodi is a ghost town at the southern tip of Rameswaram, destroyed by a 
                  devastating cyclone in 1964. Today, it stands as a haunting reminder of nature's 
                  fury, with ruins of buildings, a church, and a railway station still visible.
                </p>
                <p className="dhanushkodi-description">
                  The town is located at the confluence of the Bay of Bengal and the Indian Ocean, 
                  offering breathtaking views. The drive through the sand dunes to Dhanushkodi is 
                  an adventure in itself, with the sea on both sides of the road.
                </p>
                <div className="dhanushkodi-tips">
                  <div className="dest-tip">
                    <i className="fas fa-car"></i>
                    <span>Only jeeps and 4x4 vehicles can reach Dhanushkodi</span>
                  </div>
                  <div className="dest-tip">
                    <i className="fas fa-clock"></i>
                    <span>Best time to visit: Morning hours (6 AM - 10 AM)</span>
                  </div>
                  <div className="dest-tip">
                    <i className="fas fa-camera"></i>
                    <span>Photography paradise - carry extra batteries!</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Pamban Bridge Section */}
        <div className="pamban-section">
          <Grid>
            <Row>
              <Col xs={12} md={6} className="pamban-content">
                <div className="pamban-badge">Engineering Marvel</div>
                <h2 className="pamban-title">Pamban Bridge</h2>
                <p className="pamban-description">
                  The Pamban Bridge is India's first sea bridge, connecting Rameswaram Island to 
                  mainland India. This engineering marvel features a double-leaf bascule section 
                  that can be raised to allow ships to pass through.
                </p>
                <p className="pamban-description">
                  Built in 1914, the bridge offers spectacular views of the ocean and is a popular 
                  spot for watching sunsets. The railway bridge runs parallel to the road bridge, 
                  creating a unique sight.
                </p>
                <div className="pamban-stats">
                  <div className="stat">
                    <span className="number">1914</span>
                    <span className="label">Year Built</span>
                  </div>
                  <div className="stat">
                    <span className="number">2.3</span>
                    <span className="label">Km Length</span>
                  </div>
                  <div className="stat">
                    <span className="number">First</span>
                    <span className="label">Sea Bridge of India</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Travel Tips Section */}
        <div className="dest-tips-section">
          <Grid>
            <div className="dest-section-header">
              <h2 className="dest-section-title-centered">Travel Tips for Rameswaram</h2>
              <p className="dest-section-subtitle">Make the most of your pilgrimage</p>
            </div>
            <Row className="tips-grid">
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <h4>Best Time to Visit</h4>
                  <p>October to April offers pleasant weather for temple visits and sightseeing.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-tshirt"></i>
                  </div>
                  <h4>Dress Code</h4>
                  <p>Traditional attire required for temple visits. Cover shoulders and knees.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-ship"></i>
                  </div>
                  <h4>Dhanushkodi Trip</h4>
                  <p>Start early morning for Dhanushkodi. Shared jeeps available from the town.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-utensils"></i>
                  </div>
                  <h4>Must Try</h4>
                  <p>Fresh seafood, temple prasadam, and local Tamil cuisine.</p>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* CTA Section */}
        <div className="dest-cta-section">
          <div className="dest-cta-content">
            <h3>Embark on a Spiritual Journey</h3>
            <p>Let us help you plan your pilgrimage to Rameswaram</p>
            <Link to="/contact" className="dest-cta-button">
              Plan Your Trip
              <i className="fas fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}